import { CreateContractPersonBodyDto } from '@ekt-group/general-purpose-api-interfaces';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MutationConfig, mutationFn } from '@/lib/react-query';

const updateContractPersonFn = ({ id, data }: { data: Partial<CreateContractPersonBodyDto>; id: number }) => {
  return mutationFn(`/contracts/persons/${id}`, data, 'patch');
};

type UseUpdateContractPersonOptions = {
  mutationConfig?: MutationConfig<typeof updateContractPersonFn>;
};

export const useUpdateContractPerson = ({ mutationConfig }: UseUpdateContractPersonOptions) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: async (data, ...args) => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('contract-persons'),
      });
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: (data: { data: Partial<CreateContractPersonBodyDto>; id: number }) => updateContractPersonFn(data),
  });
};
